import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import { renderRichText as richTextRenderer } from 'gatsby-source-contentful/rich-text'
import richTextOptionsPreview from '../../preview/richText.utils'
import richTextOptionsBuild from './richText.utils'

export const renderRichText = (body: any) => {
  // if coming from sdk data
  if (body.content) {
    return documentToReactComponents(body, richTextOptionsPreview)
  } else return richTextRenderer(body, richTextOptionsBuild)
}
